import { CardMedia, Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Close } from '@material-ui/icons'
import React from 'react'
import { gray } from '../../../utils/colors'

const useStyles = makeStyles(() => ({
	dialogTitle: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 18,
		paddingLeft: '1.5rem',
		paddingRight: '0.75rem',
		paddingBottom: '0.5rem',
		borderBottomWidth: '1px',
		borderBottomStyle: 'solid',
		borderBottomColor: gray[500]
	},
	dialogContent: { padding: '0px 24px' },
	closeButton: { fill: gray[900] }
}))

const PhotoDialog = (props) => {
	const classes = useStyles()

	let { isShown, setIsShown, photoUrl, photoType, style = {} } = props
	return (
		<Dialog
			open={isShown}
			style={style}
			onClose={() => {
				setIsShown(false)
			}}
			PaperProps={{
				style: {
					minWidth: '800px',
					maxWidth: '800px',
					width: '800px',
					padding: '0.75rem 0px 1.5rem 0px'
				}
			}}>
			<DialogTitle disableTypography className={classes.dialogTitle}>
				<h2>{photoType}</h2>
				<IconButton onClick={() => setIsShown(false)}>
					<Close className={classes.closeButton} />
				</IconButton>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<CardMedia image={photoUrl} component="img" />
			</DialogContent>
		</Dialog>
	)
}

export default PhotoDialog
